// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTemplate_wrapper__oV9r_"};